import React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';

import { Topics } from '../../components/Topics';
import { changeSingleOptionQuestionAnswer } from '../actions/surveysActions';
import {
    OptionsAnswerField,
    QuestionComponentBaseProps,
    SurveySingleOptionQuestionAnswer,
} from '../models/surveys';
import { getProgramSurveySingleQuestionAnswer } from '../selectors/surveysSelectors';
import { QuestionHeader } from './QuestionHeader';
import * as S from './styles';

interface StateProps {
    answer: SurveySingleOptionQuestionAnswer | undefined;
}

interface ActionsProps {
    changeSingleOptionQuestionAnswer: typeof changeSingleOptionQuestionAnswer;
}

interface Props extends QuestionComponentBaseProps, StateProps, ActionsProps {
    options: string[];
}

export class SingleOptionQuestionContainer extends React.PureComponent<Props> {
    private changeQuestionAnswer = (value: string, field: OptionsAnswerField) => {
        const { programId, surveyId, id } = this.props;

        this.props.changeSingleOptionQuestionAnswer({
            programId,
            surveyId,
            question: id,
            field,
            value,
        });
    };

    public handleOptionChange = (value: string) => this.changeQuestionAnswer(value, 'option');

    public handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) =>
        this.changeQuestionAnswer(e.target.value, 'content');

    public render(): JSX.Element {
        const { question, placeholder, options, answer, readableIndex } = this.props;

        const isOtherOptionChosen = answer && answer.data.option && answer.data.option === 'Other';

        return (
            <>
                {question && <QuestionHeader index={readableIndex} header={question} />}
                <Topics
                    topics={options}
                    selectedTopics={answer && answer.data.option ? [answer.data.option] : undefined}
                    capitalize
                    onTopicChange={this.handleOptionChange}
                />
                {isOtherOptionChosen && (
                    <S.StyledInput
                        value={answer && answer.data.content}
                        size="large"
                        placeholder={placeholder}
                        onChange={this.handleInputChange}
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = (state: AppState, { programId, surveyId, id }: Props): StateProps => ({
    answer: getProgramSurveySingleQuestionAnswer(state, programId, surveyId, id) as
        | SurveySingleOptionQuestionAnswer
        | undefined,
});

export const SingleOptionQuestion = connect(mapStateToProps, {
    changeSingleOptionQuestionAnswer,
})(SingleOptionQuestionContainer);
